import React from "react";

interface ColumnProps extends React.HTMLAttributes<HTMLElement>{  
  columnname?: string | undefined
  columnwidth: number  
}

class Column extends React.Component<ColumnProps> {
  render() {
    return (     
      <div        
        {...this.props}
        style={{ ...this.props.style,width: this.props.columnwidth }}
      >
        {this.props.columnname}
      </div>
    );
  }
}

export default Column;